import Reveal from '@/components/Reveal';
import { homeMock } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="relative w-full overflow-hidden bg-mahjong-cream py-32 md:py-40">
      <div className="pointer-events-none absolute -left-10 top-10 font-serif text-[18rem] leading-none text-mahjong-primary/5 md:text-[28rem]">
        和
      </div>
      <div className="relative px-6 md:px-10 lg:px-16">
        <div className="grid gap-16 lg:grid-cols-12 lg:items-center">
          {/* Left: Text */}
          <Reveal className="lg:col-span-5 lg:translate-y-5" variant="slide-right">
            <div className="flex gap-7">
              <p
                className="font-sans text-xs tracking-[0.45em] text-mahjong-warm"
                style={{ writingMode: 'vertical-rl' }}
              >
                ABOUT US
              </p>
              <div className="h-40 w-px bg-mahjong-warm/30" />
              <div>
                <h2 className="mb-8 whitespace-pre-line font-serif text-2xl font-bold leading-relaxed text-mahjong-dark md:text-4xl lg:text-5xl">
                  {homeMock.about.title}
                </h2>
                <p className="mb-8 max-w-md whitespace-pre-line font-sans text-sm leading-relaxed text-mahjong-dark/80 md:text-base">
                  {homeMock.about.description}
                </p>

                {/* CTA Button */}
                <button
                  onClick={() => {
                    const el = document.querySelector('#pricing');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 rounded-full bg-mahjong-primary/10 px-6 py-3 font-sans text-sm font-medium text-mahjong-primary transition-all hover:bg-mahjong-primary hover:text-white"
                >
                  コースを見る
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </Reveal>

          {/* Right: Image Card */}
          <Reveal className="lg:col-span-7" variant="slide-left">
            <div className="relative ml-auto max-w-[92%] md:max-w-none">
              <div className="relative h-[480px] overflow-hidden rounded-2xl md:h-[560px]">
              <img
                src={homeMock.about.image}
                alt="雀荘 和外観"
                className="h-full w-full object-cover object-top"
              />
              {/* Bottom Gradient & Info */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6 md:p-8">
                <p className="font-serif text-lg font-bold text-white">
                  東京都新宿区
                </p>
                <p className="mt-1 font-sans text-sm text-white/80">
                  駅徒歩3分の隠れ家空間
                </p>
              </div>
            </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}